var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cmsHome"}},[_c('navbar',{staticClass:"mb-5",attrs:{"tabs":_vm.navTabs,"username":_vm.user.email,"userProfileLink":_vm.userProfileLink}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }